import { render } from "./WorkspaceHeading.vue?vue&type=template&id=5585c93e&scoped=true&ts=true&lang=html"
import script from "./WorkspaceHeading.vue?vue&type=script&lang=ts"
export * from "./WorkspaceHeading.vue?vue&type=script&lang=ts"

import "./WorkspaceHeading.vue?vue&type=style&index=0&id=5585c93e&lang=css&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5585c93e"]])

export default __exports__